const helpers = {
  generateGetParams: data =>
    Object.keys(data)
      .map(key => [key, data[key]].map(encodeURIComponent).join('='))
      .join('&')
};

export default helpers;
